import { UiTextBlockModel } from "../../models";

import { mockAdfDocument } from "./mock-adf-doc";

export function mockUiTextBlockModel({
    id = "text-block-1234",
    type = "uiTextBlock",
    locale = "en",
    content = mockUiTextBlockModelContent()
}: Partial<UiTextBlockModel> = {}): UiTextBlockModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiTextBlockModelContent = UiTextBlockModel["content"];

export function mockUiTextBlockModelContent({
    text = mockAdfDocument(),
    ...optionals
}: Partial<UiTextBlockModelContent> = {}): UiTextBlockModelContent {
    return {
        text,
        ...optionals
    };
}
